<article class="lk-reading" [attr.data-test-id]="'locks-keys-reading-panel-' + definition().id">
  <h3 class="lk-reading__title">
    <i eIcon [icon]="definition().icon" family="solid"></i>
    {{ title() }}
  </h3>
  @if (reviewNotice()) {
    <p class="lk-reading__review" data-test-id="locks-keys-reading-review">
      <i eIcon icon="circle-info" family="solid"></i>
      <span>{{ reviewNotice() }}</span>
    </p>
  }
  @if (lead()) {
    <p class="lk-reading__lead" data-test-id="locks-keys-reading-lead">{{ lead() }}</p>
  }
  @for (key of definition().sectionKeys; track key) {
    <hd-locks-keys-section [prefix]="definition().sectionPrefix + '.' + key" [sectionKey]="key"></hd-locks-keys-section>
  }
</article>
